/**
 * Does a price row apply to the unit being transacted?
 *
 * ONE rule, in ONE place, because the two consumers must never disagree: POS charges the
 * customer at the till and `GetItemSellingPrice` quotes the invoice line. A price that is
 * right on one screen and wrong on the other is worse than being wrong on both — it looks
 * like a discrepancy nobody can reproduce.
 *
 *  - A row with a BLANK `uom` applies to any unit. ERPNext stores a blank when the price
 *    was entered without one, which is most of this catalogue; treating that as "matches
 *    nothing" would leave the majority of items unpriced.
 *  - A row that NAMES a unit applies to that unit only. This is the whole point: a price
 *    entered for a box of twelve must never set the rate for one single.
 *
 * ⚠️ The parameter is structural, not one of the two `ItemPriceRow` interfaces. `posApi`
 * and `itemPriceApi` each declare their own, and neither should have to import the other's
 * types to ask this question.
 */
export function matchesRequestedUom(
  row: { uom?: string | null },
  uom: string | null | undefined,
): boolean {
  if (!uom)
    return true;

  if (!row.uom)
    return true;

  return String(row.uom).trim() === String(uom).trim();
}
